import { L, } from '../leaflet/leaflet';
import { L_latLng, } from '../leaflet/leaflet-util';
import { _$id, _addEventListener, } from '../util/dom';
import { _addKeyHandlers, } from '../service/key-handlers';
import { _$map, } from '../route-service/map';
import { _currentMode, _viewMode, _addMode, _removeMode, _cutMode, } from '../route-service/map-modes';
import { _routes, } from '../route-service/route-registry';
import { _selectRoute, _deselectRoute, _selectedRoute, _routeIsSelected, } from '../route-service/select-route';
import { _$editMarkerGroup, _$viewMarkerGroup, _$lineGroup, } from '../route-service/event-handler-groups';
import { _setToPrependMode, _setToAppendMode, } from '../route-model/Route';
import { _addRoute, _removeRoute, _removeMultipleRoutes, _addPoint, _removePoint, _insertPoint, _movePoint, _joinRoutes, _cutRouteAtLine, _cutRouteAtPoint, _reverseRoute, } from './edit-route';
const _handleMapClick = (clickEvent) => {
    if (_currentMode() !== _addMode) {
        return;
    }
    const selectedRoute = _selectedRoute(), latLng = clickEvent.latlng;
    if (selectedRoute) {
        _addPoint(latLng, selectedRoute);
    }
    else {
        const $map = clickEvent.sourceTarget, route = _addRoute([latLng], $map);
        _selectRoute(route);
    }
}, _handleEditMarkerClick = (clickEvent) => {
    const $marker = clickEvent.sourceTarget, route = $marker.p().r();
    switch (_currentMode()) {
        case _addMode:
            _handleAddModeMarkerClick($marker, route);
            break;
        case _removeMode:
            _removePoint($marker);
            break;
        case _cutMode:
            _cutRouteAtPoint($marker, _$map);
            break;
    }
}, _handleViewMarkerClick = (clickEvent) => {
    const $viewMarker = clickEvent.sourceTarget, route = $viewMarker.r();
    switch (_currentMode()) {
        case _addMode:
            _handleAddModeViewMarkerClick($viewMarker, route);
            break;
        default:
            const toggleSelection = _routeIsSelected(route) ?
                _deselectRoute : _selectRoute;
            toggleSelection(route);
    }
}, _handleLineClick = (clickEvent) => {
    L.DomEvent.stopPropagation(clickEvent);
    const $mapLine = clickEvent.sourceTarget, line = $mapLine.ln(), route = line.r(), routeIsSelected = _routeIsSelected(route), currentMode = _currentMode();
    if (routeIsSelected) {
        switch (currentMode) {
            case _addMode:
                const latLng = clickEvent.latlng;
                _insertPoint(latLng, line);
                break;
            case _viewMode:
            case _removeMode:
                _deselectRoute(route);
                break;
            case _cutMode:
                _cutRouteAtLine($mapLine, _$map);
                break;
        }
    }
    else {
        _selectRoute(route);
    }
}, _handleMarkerDragStart = (dragStartEvent) => {
    const $marker = dragStartEvent.sourceTarget, { lat, lng } = $marker.getLatLng();
    _oldLat = lat;
    _oldLng = lng;
}, _handleMarkerMoveEnd = (moveendEvent) => {
    const $marker = moveendEvent.sourceTarget, oldLatLng = L_latLng(_oldLat, _oldLng), newLatLng = Object.assign({}, $marker.getLatLng());
    _movePoint($marker, oldLatLng, newLatLng);
}, _handleLayeraddForDragWorkaround = (layeraddEvent) => {
    layeraddEvent.layer.on({
        dragstart: _handleMarkerDragStart,
        moveend: _handleMarkerMoveEnd,
    });
}, _handleLayerremoveForDragWorkaround = (layerremoveEvent) => {
    layerremoveEvent.layer.off();
}, _handleAddModeMarkerClick = ($marker, route) => {
    switch ($marker.p()) {
        case route.s():
            _setToPrependMode(route);
            break;
        case route.e():
            _setToAppendMode(route);
            break;
        default:
            _deselectRoute(route);
    }
}, _handleAddModeViewMarkerClick = ($viewMarker, unselectedRoute) => {
    const $selectedRoute = _selectedRoute();
    if ($selectedRoute) {
        switch ($viewMarker) {
            case unselectedRoute.sv():
                _joinRoutes($selectedRoute, unselectedRoute, _$map);
                break;
            case unselectedRoute.ev():
                _joinRoutes(unselectedRoute, $selectedRoute, _$map);
                break;
        }
    }
    else {
        _selectRoute(unselectedRoute);
    }
}, _clearAllRoutes = () => {
    const allRoutes = _routes();
    _removeMultipleRoutes(allRoutes);
}, _removeSelectedRoute = () => {
    const selectedRoute = _selectedRoute();
    if (!selectedRoute) {
        return;
    }
    _removeRoute(selectedRoute);
}, _reverseSelectedRoute = () => {
    const selectedRoute = _selectedRoute();
    if (!selectedRoute) {
        return;
    }
    _reverseRoute(selectedRoute, _$map);
}, _$reverseButton = _$id('reverse-button'), _$deleteButton = _$id('delete-button'), _$clearButton = _$id('clear-button');
let _oldLat = 0, _oldLng = 0;
_$map.on('click', _handleMapClick);
_$editMarkerGroup.on({
    click: _handleEditMarkerClick,
    layeradd: _handleLayeraddForDragWorkaround,
    layerremove: _handleLayerremoveForDragWorkaround,
});
_$viewMarkerGroup.on('click', _handleViewMarkerClick);
_$lineGroup.on('click', _handleLineClick);
_addEventListener(_$reverseButton, 'click', _reverseSelectedRoute);
_addEventListener(_$deleteButton, 'click', _removeSelectedRoute);
_addEventListener(_$clearButton, 'click', _clearAllRoutes);
_addKeyHandlers('f', _reverseSelectedRoute);
_addKeyHandlers('d', _removeSelectedRoute);
_addKeyHandlers('x', _clearAllRoutes);
